import type { ReactNode } from "react"
import React from "react"

import { useTranslation } from "@bounce/i18n"

import { Map } from "./Map"
import type { Interpolations } from "../hooks/useInterpolations"
import type { StoreData } from "@/libs/bounce/stores/types"

export type HeroContainerProps = {
  children: ReactNode
  store: StoreData
  interpolations: Interpolations
}

export const HeroContainer = ({ children, store, interpolations }: HeroContainerProps) => {
  const { t } = useTranslation("marketing-ls-store")

  return (
    <header className="mx-auto flex w-screen flex-col sm:mb-20 sm:flex-row sm:items-start md:max-w-screen-xl">
      <div className="max-w-screen order-2 mx-auto w-screen gap-4 px-6 pb-12 sm:order-1 sm:pt-8">
        <div className="h-full pr-0 sm:pr-2.5">{children}</div>
      </div>
      <div className="order-1 w-screen sm:order-2">
        <Map store={store} alt={t("screen.storeScreen.map.altV2", "Map of {{STORE_GMB_NAME}}", interpolations)} />
      </div>
    </header>
  )
}
